import { createContext } from "react"

import type { WorkflowCanvasContextType, WorkflowSchemaContextType } from "../types/interfaces"

/**
 * Context for sharing workflow canvas state across components.
 * Provides access to workflow data, loading states, mode, and formik instance.
 */
export const WorkflowCanvasContext = createContext<WorkflowCanvasContextType>({
  mode: "view",
  isWorkflowLoading: false,
  isWorkflowFetching: false,
  isWorkflowsLoading: false,
  workflow: undefined,
  formik: undefined,
  onEdgesChange: () => {
    // Default empty implementation for context default value
  },
})

/**
 * Context for managing workflow schema dialog state.
 * Handles file uploads, conflicts resolution, and step navigation.
 */
export const WorkflowSchemaContext = createContext<WorkflowSchemaContextType>({
  setStep: () => {
    // Default empty implementation for context default value
  },
  setIsNextStepEnabled: () => {
    // Default empty implementation for context default value
  },
  acceptedFile: [],
  setAcceptedFile: () => {
    // Default empty implementation for context default value
  },
  conflictsList: {
    unUsedFeatures: {},
    inUseFeatures: {},
  },
  setConflictsList: () => {
    // Default empty implementation for context default value
  },
})
